import { createFileRoute } from '@tanstack/react-router';

import { client } from '@@api/client';
import { handleLoaderError } from '@@router/handleLoaderError';

import CollectionForm from './-components/CollectionForm';

export const Route = createFileRoute('/_authenticated/collections/$collectionId')({
    context: ({ params }) => ({
        collectionQuery: client.tenant.collection.get.queryOptions(
            { params: { id: Number(params.collectionId) } },
            { refetchOnWindowFocus: false },
        ),
    }),
    loader: ({ context }) =>
        context.queryClient
            .query({ ...context.collectionQuery, staleTime: 'static' })
            .catch(handleLoaderError),
    component: CollectionForm,
});
